import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSession } from './Session'

const AuthorizedRoute = ({ component, ...rest }) => {
  const { logged } = useSession()

  if (logged === null) return <div>Loading...</div>
  if (logged !== true) return <Redirect push to="/login" />
  return <Route component={component} {...rest} />
}

export default AuthorizedRoute
